
import { useEffect, useState } from 'react';
import { CleanRequestService, CleanInterviewRequest } from '@/services/interview/requests/cleanRequestService';

interface UseCleanInterviewRequestProps {
  requestLink: string;
}

export const useCleanInterviewRequest = ({ requestLink }: UseCleanInterviewRequestProps) => {
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState<CleanInterviewRequest | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('useCleanInterviewRequest: Effect triggered with requestLink:', requestLink);
    
    if (!requestLink) {
      console.log('useCleanInterviewRequest: No request link provided');
      setError('No request link provided');
      setLoading(false);
      return;
    }

    const fetchRequest = async () => {
      console.log('useCleanInterviewRequest: Starting fetch...');
      setLoading(true);
      setError(null);
      
      try {
        console.log('useCleanInterviewRequest: Calling CleanRequestService.getByLink...');
        const data = await CleanRequestService.getByLink(requestLink);
        console.log('useCleanInterviewRequest: Service returned:', data);
        
        if (!data) {
          console.log('useCleanInterviewRequest: No data returned from service');
          setError('Interview request not found');
          setRequest(null);
        } else if (data.status === 'completed') {
          console.log('useCleanInterviewRequest: Interview already completed');
          setError('This interview has already been completed');
          setRequest(null);
        } else if (data.expires_at && new Date(data.expires_at) < new Date()) {
          console.log('useCleanInterviewRequest: Interview expired');
          setError('This interview request has expired');
          setRequest(null);
        } else {
          console.log('useCleanInterviewRequest: Setting valid request data');
          setRequest(data);
          setError(null);
        }
      } catch (fetchError) {
        console.error('useCleanInterviewRequest: Error in fetchRequest:', fetchError);
        setError('Failed to load interview request');
        setRequest(null);
      }
      
      setLoading(false);
    };

    console.log('useCleanInterviewRequest: Calling fetchRequest...');
    fetchRequest().catch(error => {
      console.error('useCleanInterviewRequest: Unhandled error in fetchRequest:', error);
      setError('Unexpected error occurred');
      setLoading(false);
    });
  }, [requestLink]);

  return { loading, request, error };
};
